import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';

const alignLeft = (element: ElementType, leftX: number) => {
    const box = getBoundingBox(element);
    const offsetX = element.x - box.minX;
    element.set({ x: leftX + offsetX });
};

export function alignElementsLeft(elements: ElementsArray) {
    const leftX = elements.length > 1 ? Math.min(...elements.map(getBoundingBox).map(box => box.minX)) : 0;

    elements.forEach(element => {
        alignLeft(element, leftX);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignLeft(child, leftX);
            });
        }
    });
}
